
import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { CreateFacilityOrderTemplateNewPatientNewFlowModalTemplate } from 'themes/application/facility-order-new-flow/components';
import { CreateFacilityOrderTemplateNewPatientNewFlowModalStore } from 'application/facility-order-new-flow/stores';

@setCurrentView((rootStore, componentProps) => new CreateFacilityOrderTemplateNewPatientNewFlowModalStore(rootStore, componentProps), 'createFacilityOrderTemplateNewPatientNewFlowModalStore')
@observer
class CreateFacilityOrderTemplateNewPatientNewFlowModal extends React.Component {
    render() {
        return <CreateFacilityOrderTemplateNewPatientNewFlowModalTemplate {...this.props} />
    }
}

export default CreateFacilityOrderTemplateNewPatientNewFlowModal;
